import bg from './message-bg'
import cs from './message-cs'
import en from './message-en'
import fr from './message-fr'
import id from './message-id'
import lt from './message-lt'
import sk from './message-sk'
import tr from './message-tr'
import he from './message-he'
import ne from './message-ne'
import nl from './message-nl'
import hu from './message-hu'
import hi from './message-hi'
import ro from './message-ro'
import ta from './message-ta'
import pa from './message-pa'
import sl from './message-sl'
import lv from './message-lv'
import enAu from './message-en-au'
import enCa from './message-en-ca'
import enUs from './message-en-us'
import enNz from './message-en-nz'

export default {
  'en-gb': en,
  'en-au': enAu,
  'en-ca': enCa,
  'en-us': enUs,
  'en-nz': enNz,
  bg,
  cs,
  fr,
  id,
  lt,
  he,
  hu,
  hi,
  ro,
  ne,
  nl,
  sk,
  sl,
  tr,
  ta,
  pa,
  lv
}
